export default function (number: number, index: number): [string, string] {
    return [
        ['åå', 'çå»å¾'],
        ['%s ç§å', '%s ç§å¾'],
        ['1 åéå', '1 åéå¾'],
        ['%s åéå', '%s åéå¾'],
        ['1 å°æå', '1 å°æå¾'],
        ['%s å°æå', '%s å°æå¾'],
        ['1 å¤©å', '1 å¤©å¾'],
        ['%s å¤©å', '%s å¤©å¾'],
        ['1 é±å', '1 é±å¾'],
        ['%s é±å', '%s é±å¾'],
        ['1 åæå', '1 åæå¾'],
        ['%s åæå', '%s åæå¾'],
        ['1 å¹´å', '1 å¹´å¾'],
        ['%s å¹´å', '%s å¹´å¾'],
    ][index] as [string, string];
}
